import { DataLoadedStatus, PolicyAppState } from '../../types';
import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PoliciesReduxActions } from '../../actions';

// SELECTORS
export const getIsIntegrityMonitorCompanyRuleSetsLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.INTEGRITY_MONITOR]?.sections[SectionId.INTEGRITY_MONITOR_REAL_TIME].additionalInfo
    .companyRuleSetsLoaded ?? DataLoadedStatus.NOT_LOADED;
export const getIsIntegrityMonitorSelectedRuleSetsLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.INTEGRITY_MONITOR]?.sections[SectionId.INTEGRITY_MONITOR_REAL_TIME].additionalInfo
    .selectedRuleSetsLoaded ?? DataLoadedStatus.NOT_LOADED;

// ACTIONS
export const setCompanyRuleSetsLoadedForIntegrityMonitor = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_COMPANY_RULE_SETS_LOADED_FOR_INTEGRITY_MONITOR
);
export const setCompanyRuleSetsLoadedForIntegrityMonitorActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.INTEGRITY_MONITOR];

  if (!module) {
    return;
  }

  module.sections[SectionId.INTEGRITY_MONITOR_REAL_TIME].additionalInfo.companyRuleSetsLoaded = action.payload;
};

export const setSelectedRuleSetsLoadedForIntegrityMonitor = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_SELECTED_RULE_SETS_LOADED_FOR_INTEGRITY_MONITOR
);
export const setSelectedRuleSetsLoadedForIntegrityMonitorActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.INTEGRITY_MONITOR];

  if (!module) {
    return;
  }

  module.sections[SectionId.INTEGRITY_MONITOR_REAL_TIME].additionalInfo.selectedRuleSetsLoaded = action.payload;
};
